import { Component } from '@angular/core';

@Component({
  selector: 'mom-header-menu',
  templateUrl: './header-with-menu.component.html',
  styleUrls: ['./header-with-menu.component.scss']
})
export class HeaderWithMenuComponent {}
